import React, { useState } from 'react';
import { useTon } from './TelegramTonProvider';
import { useTelegram } from './TelegramProvider';

const AirdropPage = () => {
  const { wallet, connected, address } = useTon();
  const { user } = useTelegram();

  const rawAddr = wallet?.account?.address || address || '';
  const [walletInput, setWalletInput] = useState(rawAddr);
  const [tgInput,     setTgInput]     = useState(user?.username ? `@${user.username}` : '');
  const [status,      setStatus]      = useState('idle');
  const [errorMsg,    setErrorMsg]    = useState('');
  const [regNumber,   setRegNumber]   = useState('');
  const [section,     setSection]     = useState('overview'); // 'overview' | 'register'

  const handleSubmit = async () => {
    const w = walletInput.trim();
    if (!w || w.length < 10) { setErrorMsg('Enter a valid TON wallet address (UQ... or EQ...)'); return; }
    setStatus('loading'); setErrorMsg('');
    try {
      const res = await fetch('/.netlify/functions/airdrop-register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          wallet: w,
          telegram: tgInput.replace('@', '').trim() || null,
          network: 'TON',
          telegramUserId: user?.id || null,
        }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) throw new Error(data.error || 'Unknown error');
      setRegNumber(data.registrationNumber || '');
      setStatus('success');
    } catch (err) {
      setErrorMsg(err.message || 'Something went wrong, try again');
      setStatus('error');
    }
  };

  /* ── SUCCESS SCREEN ── */
  if (status === 'success') {
    return (
      <div style={{ padding: '0 16px 96px', textAlign: 'center', paddingTop: 40 }}>
        <div style={{ fontSize: 80, marginBottom: 12 }}>🎉</div>
        <div style={{ fontSize: 22, fontWeight: 900, color: 'var(--gold)', marginBottom: 4 }}>
          You're on the list!
        </div>
        {regNumber && (
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20 }}>
            💎 TON Registration #{regNumber}
          </div>
        )}
        <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: 16 }}>
          Your wallet is registered for the<br />
          <strong style={{ color: 'var(--gold)' }}>💎 600M LILAPE TON Giveaway</strong>.<br />
          Prizes distributed at the end of Stage 4.
        </div>
        <div style={{ padding: 14, borderRadius: 'var(--radius-md)', background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)', marginBottom: 12, fontSize: 13, color: 'var(--text-secondary)' }}>
          📩 Check Telegram — APE bot sent you a confirmation!
        </div>
        <div className="glass-card" style={{ padding: 14, textAlign: 'left', marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>Registered TON wallet</div>
          <div style={{ fontSize: 11, fontFamily: 'monospace', color: 'var(--green)', wordBreak: 'break-all' }}>{walletInput}</div>
        </div>
        <div style={{ padding: 14, borderRadius: 'var(--radius-md)', background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)', fontSize: 13, color: 'var(--text-secondary)' }}>
          📢 Stay updated: <a href="https://t.me/little_ape" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gold)' }}>@little_ape</a>
        </div>
      </div>
    );
  }

  const prizes = [
    { place: '🥇', label: '1st Place',     amount: '250,000,000', usd: '~$500,000' },
    { place: '🥈', label: '2nd Place',     amount: '150,000,000', usd: '~$300,000' },
    { place: '🥉', label: '3rd Place',     amount: '100,000,000', usd: '~$200,000' },
    { place: '🎁', label: '100 Runner-Up', amount: '1,000,000 each', usd: '~$2,000 each' },
  ];

  const ticketRules = [
    { icon: '⚡', title: 'Buy in Stage 1 (NOW LIVE)', desc: '2× ticket bonus — limited time!', highlight: true },
    { icon: '🛒', title: 'Buy LILAPE on TON',         desc: '1 ticket per 0.1 TON spent'                        },
    { icon: '💎', title: 'Hold until Stage 4 ends',   desc: '2× all your tickets'                               },
    { icon: '🖼️', title: 'Own a LILAPE NFT',          desc: '2× tickets + 2× staking APY (up to 100%)'         },
    { icon: '👥', title: 'Invite friends',             desc: '+5 bonus tickets per referral'                     },
    { icon: '🐒', title: 'Join Telegram',              desc: 'Required to claim prizes'                          },
  ];

  return (
    <div style={{ paddingBottom: 96 }}>

      {/* Header */}
      <div className="page-header">
        <div className="page-header-icon gold">💎</div>
        <div>
          <div className="page-title">TON Giveaway</div>
          <div className="page-subtitle">600M LILAPE · TON Blockchain</div>
        </div>
      </div>

      {/* Tab switcher */}
      <div style={{ display: 'flex', margin: '0 16px 16px', gap: 8 }}>
        {[['overview', '🏆 Overview'], ['register', '📝 Register']].map(([id, label]) => (
          <button
            key={id}
            onClick={() => setSection(id)}
            style={{
              flex: 1, padding: '10px', borderRadius: 'var(--radius-md)',
              background: section === id ? 'rgba(245,158,11,0.18)' : 'var(--bg-secondary)',
              border: `1px solid ${section === id ? 'rgba(245,158,11,0.5)' : 'var(--border-color)'}`,
              color: section === id ? 'var(--gold)' : 'var(--text-muted)',
              fontWeight: section === id ? 700 : 400,
              fontSize: 13, cursor: 'pointer',
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {/* OVERVIEW TAB */}
      {section === 'overview' && (
        <>
          {/* Prize pool banner */}
          <div style={{ margin: '0 16px 16px', padding: 18, borderRadius: 'var(--radius-lg)', background: 'linear-gradient(135deg,rgba(245,158,11,0.12),rgba(239,68,68,0.1))', border: '1px solid rgba(245,158,11,0.35)', textAlign: 'center' }}>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 2 }}>💎 TON Chain · Total Prize Pool</div>
            <div style={{ fontSize: 30, fontWeight: 900, color: '#FCD34D', lineHeight: 1.1 }}>600,000,000</div>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--gold)', marginBottom: 4 }}>LILAPE (TON jetton)</div>
            <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>~$1,200,000 at Stage 4 target price ($0.0020/LILAPE)*</div>
          </div>

          {/* Prize distribution */}
          <div style={{ margin: '0 16px 16px' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', marginBottom: 8, letterSpacing: '0.06em' }}>PRIZE DISTRIBUTION</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {prizes.map(p => (
                <div key={p.label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: 'var(--radius-sm)', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 18 }}>{p.place}</span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>{p.label}</span>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--gold)' }}>{p.amount}</div>
                    <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>{p.usd}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Ticket rules */}
          <div style={{ margin: '0 16px 16px' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', marginBottom: 8, letterSpacing: '0.06em' }}>🎟 HOW TO EARN TICKETS</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {ticketRules.map((r, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 12px', borderRadius: 'var(--radius-sm)', background: r.highlight ? 'rgba(52,211,153,0.06)' : 'var(--bg-secondary)', border: `1px solid ${r.highlight ? 'rgba(52,211,153,0.3)' : 'var(--border-color)'}` }}>
                  <span style={{ fontSize: 18, flexShrink: 0 }}>{r.icon}</span>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: r.highlight ? '#34d399' : 'var(--text-primary)', marginBottom: 2 }}>
                      {r.title}
                      {r.highlight && <span style={{ marginLeft: 6, fontSize: 9, background: '#34d399', color: '#000', borderRadius: 3, padding: '1px 4px', fontWeight: 900 }}>LIVE</span>}
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{r.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Deadline */}
          <div style={{ margin: '0 16px 12px', padding: 12, borderRadius: 'var(--radius-md)', background: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 4 }}>📅 Deadline</div>
            <div style={{ fontSize: 11, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
              Closes when <strong style={{ color: 'var(--gold)' }}>Stage 4 sells out</strong> or on <strong style={{ color: 'var(--gold)' }}>December 31, 2026</strong>. Winners announced within 14 days.
            </div>
          </div>

          {/* Cross-promo BASE */}
          <a href="https://liteape.com/#giveaway" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '0 16px 12px', padding: 12, borderRadius: 'var(--radius-md)', background: 'rgba(37,99,235,0.06)', border: '1px solid rgba(37,99,235,0.25)', textDecoration: 'none' }}>
            <span style={{ fontSize: 22 }}>🔵</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#60A5FA', marginBottom: 2 }}>Also on BASE Blockchain</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Separate 600M giveaway · liteape.com · Same prizes</div>
            </div>
            <span style={{ fontSize: 14, color: '#60A5FA' }}>›</span>
          </a>

          {/* Disclaimer */}
          <div style={{ margin: '0 16px 16px', fontSize: 10, color: 'var(--text-muted)', lineHeight: 1.5 }}>
            *Prize pool valued at Stage 4 target price ($0.0020/LILAPE). Future target, not current price. DYOR. LILAPE is a meme token.
          </div>

          {/* CTA */}
          <div style={{ padding: '0 16px' }}>
            <button onClick={() => setSection('register')} className="btn-primary">
              📝 Register for TON Giveaway →
            </button>
          </div>
        </>
      )}

      {/* REGISTER TAB */}
      {section === 'register' && (
        <div style={{ padding: '0 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>

          <div style={{ padding: 12, borderRadius: 'var(--radius-md)', background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)', fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            💎 Register your <strong style={{ color: 'var(--gold)' }}>TON wallet</strong> to join the 600M LILAPE giveaway. You'll receive a personal confirmation from the APE bot.
          </div>

          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>TON Wallet Address *</div>
            <input
              type="text"
              value={walletInput}
              onChange={e => setWalletInput(e.target.value)}
              placeholder="UQ… or EQ…"
              style={{ width: '100%', padding: '13px 14px', background: 'var(--bg-secondary)', border: `1px solid ${errorMsg ? 'var(--red)' : 'var(--border)'}`, borderRadius: 'var(--radius-sm)', color: 'var(--text-primary)', fontSize: 13, fontFamily: 'monospace', outline: 'none', boxSizing: 'border-box' }}
            />
            {connected && rawAddr && walletInput !== rawAddr && (
              <button onClick={() => setWalletInput(rawAddr)} style={{ marginTop: 6, fontSize: 11, color: 'var(--gold)', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                ↙ Use connected wallet
              </button>
            )}
            {connected && rawAddr && (
              <div style={{ marginTop: 6, fontSize: 11, color: 'var(--green)' }}>✅ Wallet connected — address auto-filled</div>
            )}
          </div>

          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>
              Telegram Username <span style={{ fontWeight: 400 }}>(optional)</span>
            </div>
            <input
              type="text"
              value={tgInput}
              onChange={e => setTgInput(e.target.value)}
              placeholder="@username"
              style={{ width: '100%', padding: '13px 14px', background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', color: 'var(--text-primary)', fontSize: 13, outline: 'none', boxSizing: 'border-box' }}
            />
          </div>

          {errorMsg && (
            <div style={{ padding: '10px 14px', borderRadius: 8, background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', fontSize: 12, color: '#F87171' }}>
              ⚠️ {errorMsg}
            </div>
          )}

          <button
            onClick={handleSubmit}
            disabled={status === 'loading' || !walletInput.trim()}
            className="btn-primary"
          >
            {status === 'loading' ? '⏳ Registering…' : '💎 Register for TON Giveaway'}
          </button>

          <div style={{ fontSize: 11, color: 'var(--text-muted)', textAlign: 'center', lineHeight: 1.6 }}>
            By registering you confirm you hold or plan to hold LILAPE (TON jetton).<br />
            Distribution announced in <a href="https://t.me/little_ape" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gold)' }}>@little_ape</a>.
          </div>
        </div>
      )}
    </div>
  );
};

export { AirdropPage };
